export const IShowLoadingUseCaseType = Symbol('IShowLoadingUseCase');
